import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["WigsMobileFilters"] */ "/app/src/app/[locale]/(shop)/wigs/WigsMobileFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ComingSoon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/product/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductFilters"] */ "/app/src/components/product/ProductFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductListing"] */ "/app/src/components/product/ProductListing.tsx");
